module.exports = __webpack_public_path__ + "static/img/user-add.d8fd5a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user-add.png
// module id = xfoU
// module chunks = 10